import API from "./api";

/* ================= GET ALL SALARY ================= */
export const getSalaryList = (params) => {
  return API.get("/salary", { params });
};

/* ================= CREATE ================= */
export const createSalary = (data) => {
  return API.post("/salary", data);
};

/* ================= GET BY ID ================= */
export const getSalaryById = (id) => {
  return API.get(`/salary/${id}`);
};

/* ================= UPDATE ================= */
export const updateSalary = (id, data) => {
  return API.put(`/salary/${id}`, data);
};

/* ================= DELETE ================= */
export const deleteSalary = (id) => {
  return API.delete(`/salary/${id}`);
};

export const markSalaryPaid = (data) => {
  return API.post("/salary/mark-paid", data);
};